<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12" sm="8">

					<v-radio-group v-model="selected">

						<a @click.prevent="selected = '1'">
							<v-card elevation="12" class="mb-3">
								<v-container fluid>
									<v-row align="center" justify="center">
										<v-col cols="1">
											<v-radio value="1"></v-radio>
										</v-col>
										<v-col cols="8">
											<v-card-title class="title">Unlimited Life Time Access</v-card-title>
											<v-card-subtitle>One Time Payment Unlimited Access & Users (Best Value)</v-card-subtitle>
										</v-col>
										<v-divider vertical></v-divider>
										<v-col cols="" align="center">
											$34350
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</a>
						<v-divider></v-divider>

						<a @click.prevent="selected = '2'">
							<v-card elevation="12" class="mb-3">
								<v-container fluid>
									<v-row align="center" justify="center">
										<v-col cols="1" >
											<v-radio value="2"></v-radio>
										</v-col>
										<v-col cols="8">
											<v-card-title class="title">Annual Subscription</v-card-title>
											<v-card-subtitle>Annual Subscription Unlimited Access & Users <br />(5% Discount)</v-card-subtitle>
										</v-col>
										<v-divider vertical></v-divider>
										<v-col cols="" align="center">
											$7832
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</a>
						<v-divider></v-divider>

						<a @click.prevent="selected = '3'">
							<v-card elevation="12" class="mb-3">
								<v-container fluid>
									<v-row align="center" justify="center">
										<v-col cols="1" >
											<v-radio value="3"></v-radio>
										</v-col>
										<v-col cols="8">
											<v-card-title class="title">Pay By The Month</v-card-title>
											<v-card-subtitle>Monthly Subscription Unlimited Access & Users</v-card-subtitle>
										</v-col>
										<v-divider vertical></v-divider>
										<v-col cols="" align="center">
											$687
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</a>
						<v-divider></v-divider>

						<a @click.prevent="selected = '4'">
							<v-card elevation="12" class="mb-3">
								<v-container fluid>
									<v-row align="center" justify="center">
										<v-col cols="1" >
											<v-radio value="4"></v-radio>
										</v-col>
										<v-col cols="8" class="mb-0 pb-0">
											<v-card-title class="title">Pay Per User</v-card-title>
											<v-card-subtitle>
												$15 Per User Monthly Subscription<br />
												Best Choice For Under 40 Employees
											</v-card-subtitle>
											<v-card-text>
											<v-select
											class="mt-4"
											  :items="selects"
											  v-model="select"
											  prepend-icon="group_add"
											  label="Choose Quantity"
											  dense
											></v-select>
										</v-card-text>
										</v-col>
										<v-divider vertical></v-divider>
										<v-col cols="" align="center">
											${{price}}
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</a>

						<a @click.prevent="selected = '5'">
							<v-card elevation="12" class="mb-3">
								<v-container fluid>
									<v-row align="center" justify="center">
										<v-col cols="1" >
											<v-radio value="5"></v-radio>
										</v-col>
										<v-col cols="8">
											<v-card-title class="title">Pay By The Day</v-card-title>
											<v-card-subtitle>Unlimited Access & Users Charged Daily</v-card-subtitle>
										</v-col>
										<v-divider vertical></v-divider>
										<v-col cols="" align="center">
											$23
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</a>

					</v-radio-group>
				</v-col>
				<v-col cols="12" sm="4" align="center" justify="center">
					<v-row>
						<v-col cols="12" align="center" justify="center">
							<v-checkbox v-model="checked">
								<template v-slot:label>
									<div class="pl-2 text-capitalize">
										I have read and agree to the 
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<a
												target="_blank"
												href="/tos"
												@click.stop
												v-on="on"
												>
												Terms of service
											</a>
										</template>
										Click To Read
									</v-tooltip>
								</div>
							</template>
						</v-checkbox>
						<v-btn class="btn primary d-inline-block mx-auto mt-2" @click="subscribe()" :disabled="!checked" >Subscribe</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<!-- <v-row>
			<v-col class="subtitle-1 font-weight-medium">
				<p>
					If the average employee spends about 15-30 minutes hand writing options, calculating pricing 
					and financing for each customer and saves atleast 45 minutes a day using this great app, 
					That one employee will have saved at the least 15 hours a month. 
					Lets say that employee has an hourly rate of 24/hr. Thats 360 a month or alot of extra time 
					connecting with the customer. I don't know how many employees your company has, I can 
					only imagine how great of an assett this will be for your company, customers and employees.
				</p>
				<p>
					Now just for fun lets say that employee's company has 20 employees that use this app, 
					that company would save 7200/mo just in time spent hand writing options, 
					and thats not even what this app is all about! The main benefits will come from presenting 
					professional options that are legible, accurate, spelled right and more trusted/official. 
					provide clarity and Help Elminate Confusion.
				</p>
				<p class="pb-8"> 
					I have no doubt this will increase the average ticket and also when a decision maker wasn't 
					available gets to go over the options later and isn't confused by them, they're more likely 
					to call back to have the work done. Then simply pull it back up in the history when they do. 
					I built this app to help employees focus on what matters, the customers and the work. 
				good callbacks to have the work done by helping eliminate confusion for the decision maker, 				
				</p>
			</v-col>
		</v-row> -->
	</v-container>
	<Calculator />
</div>
</template>
<script>
let stripe = Stripe('pk_test_IoO6okKBnbySX0kFFU5gU3ju00Bw4MdJwW')
import Calculator from '../components/Calculator.vue'
import firebase from '../helpers/firebaseConfig'
const functions = firebase.functions()
export default {
	name: 'Payment',
	components: {Calculator},
	data(){
		return {
			sessionId: '',
			select: 25,
			selects: [
			{text: '1-15 Employees Per Month', value: 15},
			{text: '1-25 Employees Per Month', value: 25},
			{text: '1-35 Employees Per Month', value: 35}
			],
			checked: false,
			selected: null,
			plan: {
				1: '',
				2: 'annually',
				3: 'monthly',
				4: 'users',
				5: 'daily'
			}
		}
	},
	computed: {
		price(){
			return (this.select * 15).toFixed(0)
		},
		checkPlan(){
			if (this.selected == 4){
				if (this.select == 15){
					return 'users15'
				}
				if (this.select == 25){
					return 'users25'
				}
				if (this.select == 35){
					return 'users35'
				}
				
			} else {
				return this.plan[this.selected]
			}
		}
	},
	watch:{

	},
	methods: {
		subscribe(){
			if (this.selected != null){
				if (this.selected == 1){
					functions.httpsCallable('unlimited')({
						email: this.$store.state.user.email,
						cId: this.$store.state.user.cId
					})
					.then((res)=>{
						console.log('response', res)
						this.sessionId = res.data.id
						this.checkout()
					})
				} else {
					functions.httpsCallable('checkout')({
						plan: this.checkPlan,
						email: this.$store.state.user.email,
						cId: this.$store.state.user.cId
					})
					.then((res)=>{
						console.log('response', res)
						this.sessionId = res.data.id
						this.checkout()
					})
				}
			} else {
				this.$store.commit('setSnack', "Please Choose One Of The Subscriptions")
			}
		},
		checkout(){
			stripe.redirectToCheckout({
				sessionId: this.sessionId
			}).then(function (result) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      console.log('result', result)
  });
		}
	},
	created(){
  // functions.httpsCallable('checkout')()
  // .then((res)=>{
  //   console.log('response', res)
  //   this.sessionId = res.data.id
  // })
}
}

</script>

<style type="text/css" media="screen">

</style>
